import { useMemo } from 'react';
import { createApiClient } from '../api/index.js';
import { useAuth } from '../auth/index.js';

export function useApiClient() {
  const { getIdToken } = useAuth();
  return useMemo(() => createApiClient(getIdToken), [getIdToken]);
}
